<template>
  <Modal :id="'cpm-booking-promoters-send_permission-modal'" @cancelled="onCancel">
    <template slot="header">{{ selectedItem.title }}</template>
    <template slot="body">
      <div class="form-group">
        <TextField
          :id="'pro_perm_email_sub'"
          v-bind="textFieldConfig"
          required
          :placeholder="$t('email_subject')"
          v-model="selectedItem.subject"
        ></TextField>
        <TextField
          :id="'pro_perm_email_body'"
          textarea
          :height="135"
          v-bind="textFieldConfig"
          v-model="selectedItem.emailbody"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <div class="right-buttons" style="flex:5"></div>
      <div class="right-buttons">
        <button class="dt-button s6" @click.stop="onCancel">
          {{ $t("cancel") }}
        </button>
        <button class="dt-button s6 v1" @click="onClickSend">
          {{ $t("send") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import {
  BookingStoreNamespace as storeNS,
  BookingStoreNamespace,
} from "../../store";
import * as ActionTypes from "../../store/types";

import { mapGetters, mapActions } from "vuex";
import TextField from "@plugins/text-field/text-field";
import InputField from "../../../../plugins/text-field/input-field";
import { bookingPromotersService } from "../../services/booking-promoters.service";

export default {
  props: ["selectedItem"],
  components: {
    TextField,
    InputField,
    Modal,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
    };
  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onClickSend: function () {
      // console.log(this.selectedItem);
      bookingPromotersService
        .sendPermissionMail(this.selectedItem)
        .then((res) => {
          // console.log(res);
        });
      this.$emit("cancelled", true);
    },
  },
};
</script>
